import React, { useState } from 'react';
import { Typography, Grid, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconUnderlay, Snackbar } from '@advisorycloud/react-ui-components';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { useLocation } from 'react-router-dom';
import { forgotPassword } from '../../services/Authentication';
import { Transitions } from '../../services/Transition';
import CardFooter from '../../components/CardFooter';

const useStyles = (isSM) => ({
  sentEmail: {
    marginTop: '10px',
    maxWidth: '450px',
    textAlign: 'center',
    color: 'secondary.dark',
  },
  textClickEmail: {
    marginTop: '30px',
    marginBottom: '30px',
    maxWidth: '400px',
    textAlign: 'center',
    color: 'secondary.dark',
  },
  icon: {
    fontSize: '70px',
    color: 'error.main',
  },
  supportButton: {
    padding: '0px',
    border: 'none',
    backgroundColor: 'transparent',
    height: '13px',
    marginBottom: '4px',
    minWidth: '272px',
    color: 'primary.main',
    display: 'inline-flex',
    cursor: 'pointer',
  },
  supportLabelContainer: {
    display: 'flex',
    flexDirection: isSM ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  supportLabel: {
    display: 'inline-flex',
    marginLeft: '2px',
    marginTop: '4px',
    color: 'secondary.dark',
  },
});

function ErrorReset(props) {
  const { errorType } = props;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles(isSM);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [severityHandler, setSeverityHandler] = useState('');

  async function handleRequest() {
    const isRequestOk = await forgotPassword(email);

    if (isRequestOk) {
      setText(t('REQUEST_RESET_SNACKBAR'));
      setSeverityHandler('success');
      setOpen(true);
    } else {
      setText(t('FORGOT_PASSWORD_API_ERROR'));
      setSeverityHandler('error');
      setOpen(true);
    }
  }

  function handleClose() {
    setOpen(false);
  }

  const ExpiredLinkWindow = () => {
    return (
      <>
        <Typography variant="h2" color="textSecondary" sx={classes.sentEmail}>
          {`${t('EXPIRED_LINK')} ${email}.`}
        </Typography>
        <Typography
          variant="h2"
          color="textSecondary"
          sx={classes.textClickEmail}
        >
          {t('REQUEST_RESET_CLICK_EMAIL')}
        </Typography>

        <CardFooter onClickFooter={handleRequest} mailto />
      </>
    );
  };

  const FailWindow = () => {
    return (
      <>
        <Typography variant="h2" color="textSecondary" sx={classes.sentEmail}>
          {t('VERIFY_ERROR')}
        </Typography>
        <Typography
          variant="h2"
          color="textSecondary"
          sx={classes.textClickEmail}
        >
          {t('CALL_US')}
        </Typography>
      </>
    );
  };

  function resetWindowSelection() {
    if (errorType === Transitions.Types.EXPIRED_CODE) {
      return <ExpiredLinkWindow />;
    }
    if (errorType === Transitions.Types.FAIL_CODE) {
      return <FailWindow />;
    }
    return undefined;
  }

  const ErrorResetWindow = () => {
    return (
      <>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          spacing={2}
        >
          <Grid item>
            <IconUnderlay size={90}>
              <PriorityHighIcon style={classes.icon} />
            </IconUnderlay>
          </Grid>
          <Grid item>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              {resetWindowSelection()}

              <Snackbar
                open={open}
                text={text}
                onClose={handleClose}
                severity={severityHandler}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  return <ErrorResetWindow />;
}

export default ErrorReset;
